<template>
    <div class="row mt-5 pt-3">
        <div class="col-6 col-sm-4 col-md-3 px-4 my-3 my-lg-0 d-flex align-content-center ">
            <p class="text-md text-white m-0 my-auto">
                <img class="ms-2" width="20" src="/front/assets/images/scale-white.png" alt="" title="">
                وزن (Kg)
            </p>
        </div>
        <div class="col-6 col-sm-8 col-md-3 my-3 my-sm-0 wrist">
            <div class="quantityed">
                <input
                    :dir="dir"
                    :id="id"
                    :placeholder="placeHolder"
                    ref="input"
                    v-bind="{ ...$attrs, class: null }"
                    :class="{ error: error }"
                    :type="type"
                    :value="modelValue"
                    @input="$emit('update:modelValue', $event.target.value)"
                />
            </div>
        </div>
        <div v-if="error" class="form-error">
            <p class="m-0 text-sm text-error mb-3">{{ error }}</p>
        </div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
    inheritAttrs: false,
    props: {
        ref: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default() {
                return `weight-input-${uuid()}`;
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        placeHolder: {
            type: String,
            default: '',
        },
        dir: {
            type: String,
            default: 'rtl',
        },
        error: String,
        label: String,
        modelValue: String,
    },
    emits: ['update:modelValue'],
}
</script>
